export const initialState = {
  thumbnail: null,
  productImages: []
}

export const productImageReducer = (state, action) => {
  switch (action.type) {
    case 'CHANGE_THUMBNAIL':
      return {
        ...state,
        thumbnail: action.value
      }
    case 'CHANGE_PRODUCT_IMAGES':
      return {
        ...state,
        productImages: action.value
      }
    default:
      throw new Error(`${action.type}을 찾을 수 없습니다.`);
  }
}